import { render, staticRenderFns } from "./regressionRow.vue?vue&type=template&id=60c1e75e&scoped=true"
import script from "./regressionRow.vue?vue&type=script&lang=js"
export * from "./regressionRow.vue?vue&type=script&lang=js"
import style0 from "./regressionRow.vue?vue&type=style&index=0&id=60c1e75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c1e75e",
  null
  
)

export default component.exports